import React, { useState } from 'react';
import '../../assets/css/sideBar.css';
import x_gray from '../../assets/images/x_gray.svg';
import Form from 'react-bootstrap/Form';


const TextInputClearable = ({id, placeholder, clear_function = () => {}, display="none", onChange=null, type="text"}) => {

    const clear_content = () => {
        clear_function();
        document.getElementById(id + "_input").value = '';
        document.getElementById(id + "_clear").style.display = 'none';
    }

    return (
        <div style={{ position: 'relative', display: 'inline-block' }}>
            {<Form.Control autocomplete="off" id={id + "_input"} className="sidebar-filter-input" type={type} placeholder={placeholder} onChange={onChange}/>}
            <div id={id + "_clear"} role="button" className='input-clear-btn' onClick={clear_content} style={{position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            display: display, alignItems: 'center', justifyContent: 'center'}}>
                <img src={x_gray}/>
            </div> 
        </div>
    );
};

export default TextInputClearable;